module.exports = __webpack_public_path__ + "static/media/title_tumitate_simulation.c6849076.svg";